/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IEveOrderUploadViewProps } from './eve-order-upload';

export default ({ data, dropzone, importLogger, config }: IEveOrderUploadViewProps) => {
    return data.orderUploadStorage.result?.filename && config.layout === 'evenica' ? importLogger : dropzone;
};
